import { OccConfig, ProductScope } from '@spartacus/core';

export const customtOccProductConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        product: {
          default:
            'b2b/products?fields=FULL&productCode=${productCode}',
          list: 'b2b/products?fields=FULL&productCode=${productCode}',
          details:
              'b2b/products?fields=FULL&productCode=${productCode}',
          promotions: 'products/${productCode}?fields=potentialPromotions(description)',
          attributes: 'products/${productCode}?fields=classifications',
          price: 'b2b/products/${productCode}?fields=price(formattedValue)',
          stock: 'b2b/products/${productCode}?fields=stock(FULL)',
          list_item: 'b2b/products/${productCode}?fields=code,name,price(formattedValue),images(DEFAULT),baseProduct',
        },

        productReviews: 'products/${productCode}/reviews',
        productReferences: 'b2b/products/reference?productCode=${productCode}&fields=DEFAULT',
        /* eslint-disable max-len */
        productSearch:
          'products/search?fields=products(code,name,summary,configurable,configuratorType,multidimensional,price(FULL),images(DEFAULT),stock(FULL),averageRating,variantOptions),facets,breadcrumbs,pagination(DEFAULT),sorts(DEFAULT),freeTextSearch,currentQuery',
        /* eslint-enable */
        productSuggestions: 'products/suggestions',
      },
    },
    loadingScopes: {
      product: {
        details: {
          include: [ProductScope.LIST, ProductScope.VARIANTS],
        },
      },
    },
  },
};
